<template>
  <div class="c-box" v-if="studentIds.length">
    <student-profile
      v-for="(studentId, i) in studentIds"
      :studentId="studentId"
      :key="studentId"
      :with-divider="i !== studentIds.length - 1"
    />
  </div>
</template>
<script>
import { Course } from '@/api'
import StudentProfile from '@/components/StudentProfile'

export default {
  components: {
    StudentProfile
  },
  data() {
    return {
      studentIds: []
    }
  },
  created() {
    this.fetchLecturerFromCourse()
  },
  methods: {
    async fetchLecturerFromCourse() {
      const courseData = await Course.get(this.$route.params.courseId)
      this.studentIds = courseData.data.students
    }
  }
}
</script>
